import React from 'react';
import EsgMngTemplate from '../../components/esgmng/EsgMngTemplate';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const EsgMngPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="ESG 관리/ESG 게시판/ESG 리스트" icon="notice" />
      <EsgMngTemplate />
    </div>
  );
};

export default EsgMngPage;
